export default {
  onlinePay: 'Online payment',
  selectPaymethod: 'Payment Method',
  documentTitle: 'My prize',
  goPayment: 'Pay immediately',
  waitPay: 'Pending Payment',
  specification: 'Specification',
  customize: 'Customize',
  optional: 'Optional',
  required: 'Required',
  addToCart: 'Add to Cart',
  theStoreIsClosed: 'The store is closed',
  businessHours: 'Business hours',
  mon: 'Mon',
  tues: 'Tues',
  wed: 'Wed',
  thur: 'Thur',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  categories: 'Categories',
  viewCart: 'Review Cart',
  toSettle: 'Checkout',
  clearAll: 'Clear',
  sureClearAll: 'Are you sure you want to empty the cart?',
  del_product: 'Are you sure you don\'t want it?',
  total: 'Total',
  subtotal: 'Subtotal',
  paymentMethod: 'Payment Method',
  cash: 'Cash',
  VAT: 'VAT',
  orderSubmit: 'Order Now',
  submitSuccessfully: 'Submit successfully！',
  orderNumber: 'Order Number',
  orderTime: 'Order Time',
  payTime: 'Payment Time',
  reason: 'Reason',
  cancelled: 'Cancelled',
  completed: 'Completed',
  paymentTitle: 'Payment Result',
  know: 'I know it',
  inclVAT: 'incl.VAT',
  noWownowTip: 'Open the WOWNOW APP and order',
  stopTip: 'Store is resting',
  table: 'Table',
  orderCode: 'Order Code',
  checkout: 'Checkout',
  placeOrder: 'Place order',
  waitingTip: 'Waiting For Merchant Confirmation Of Order',
  merchantsTip: 'Merchants will soon take orders.',
  cancelledTip: 'Sorry, your order was declined, please communicate with the merchant for specific reasons.',
  waitPayTip: 'Your order has been submitted, please pay in time!',
  completedTip: 'Your order is served, enjoy your meal!',
  orderSummary: 'Order summary',
  maxTip: 'Select up to {count}',
  copySuccess: 'Copy Success',
  copyFail: 'Copy Fail',
  pullDownToRefresh: "More...",
  releaseToRefresh: "More...",
  loadingText: "Loading…",
  noTableTip: 'table number is not avaliable, Please scan again.',
  notOrder: 'The following products are unavailable to purchase, please re-check.',
  orderDetail: 'Order Detail',
  cart: 'Cart',
  orderListTitle: 'My Order',
  wait: 'Pending order',
  orderShowDown: 'Displayed all order',
  amount: 'Amount',
  noOrder: 'No orders yet, place an order now!',
  orderList: 'Order list',
  remark: 'Note',
  paymentChannelOrder: 'Payment channel order',
  showOrderDetail: 'Go order detail',
  successTitle: 'Success',
  downloadTips: 'Please download the APP and use the WowNow APP to place an order',
  orderCreated: 'The current table has generated an order',
  shoppingCartChangeTip: 'Cart information has changed!',
  confirm: 'Confirm',
  cancel: 'Cancel',
  loginTips: 'Log in to your WOWNOW account for a better user experience',
  mustLogin: 'The store only supports online payment, please log in and place an order',
  goLogin: 'To log in',
  ordering: 'Direct order',
  tips: 'Tips',
  logined: 'login successful',
  confirmOrder: 'Confirm order',
  login: 'After login',
  canUse: 'Online payment can be used',
  cartExpired: 'Cart expired',
  seletedPropertyText: 'Selected property',
  changeLang: 'Change Lang',
  needDownloadWownow: 'Need to download wownow APP',
  limit99copies: 'Limit 99 copies per item',
  samePropertyLimit99: 'Products with the same specifications or attributes are limited to 99 copies,current quantity：{current}',
  plsSelectPayMethod: 'Please select the payment method first',
  zh: 'Chinese',
  en: 'English',
  km: 'Khmer'
}
